<template>
  <div 
  :class="cssMobileTheme"
  class="k-mobile-list text-weight-semi-bold">
    <Header :text="header" />

    <div class="k-flex-row k-border-bottom">
      <div class="k-flex-address">Adresse</div>
      <div class="k-flex-visit-date">Reagiert</div>
    </div>
    <div class="k-list px-2 pb-2">
      <div
        v-for="invitation in openInvitations"
        :key="invitation.id"
        class="k-invitation"
      >
        <div class="k-participant-icons">
          <div class="k-participant-icon">
            <font-awesome-icon
              class="pb-0"
              size="xs"
              color=""
              :icon="['fal', 'envelope-open']"
              v-if="invitation.visited"
            />
            <font-awesome-icon
              class="pb-0"
              size="xs"
              :icon="['fal', 'envelope']"
              v-else
            />
          </div>
        </div>
        <div class="k-flex-row">
          <div class="text-truncate">
            {{ invitation.email }}
          </div>
          <div class="k-flex-visit-date">{{ invitation | visitDate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { themeMixin } from '../mixins/ThemeMixins';
import { renderMixin } from '../mixins/RenderMixins';
import  Header from '@/components/Rendering/RenderMobileHeader.vue';

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}


export default {
  name: 'RendererMobileInvitations',
  data() {
    return {
      curParticipant: 0,
      eventInvitations: [
        {email:"a@a.de", visited:1  }
      ]
    };
  },
  mixins: [themeMixin, renderMixin],
  components: {Header},
  methods: {
    onNext() {
      if (this.curParticipant < this.participantCount) this.curParticipant++;
    },

    onBack() {
      if (this.curParticipant > 0) this.curParticipant--;
    },
  },

  filters: {
    visitDate(invitation) {
      console.log(invitation.updated_at);
      if (invitation.updated_at == invitation.created_at) return '-';
      let date = formatDate(invitation.updated_at);
      return date;
    },
  },
  computed: {
    ...mapState({
      curInvitation: (state) => state.curInvitation,
      poll: (state) => state.poll.poll,
      userId: (state) => state.Login.userId,
      ownerId: (state) => state.poll.poll.user.id,
      keyUserId: (state) => state.keyUserId,
    }),
    ...mapGetters(['isOwner']),

    invitations() {
      return this.poll.invitations;
    },

    header() {
      return this.outstandingGuest +' ' + this.$t('polls.nmbInvitation');
    },


    outstandingGuest() {
      if( !this.openInvitations) return 0;
      return this.openInvitations.length;
    },

    participant() {
      return this.participants[this.curParticipant];
    },
    participantName() {
      return this.participants[this.curParticipant].name;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/colors.scss';



$bg-color: rgba(20, 20, 20, 0.7);
$bg-color: rgba(255, 255, 255, 0.3);




.dark-mode-bg-ff {
  background-color: rgba(0, 0, 0, 0.7);
  color: $white;
}


.dark-mode-bg {
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  color: $white;
}

.light-mode-bg-ff {
  background-color: rgba(255, 255, 255, 0.7);
}


.light-mode-bg {
  background-color: $bg-color;
  backdrop-filter: blur(10px);
  color: $dark-grey;
}


.content {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
}





.k-paging {
  display: flex;
}



.k-left-icon,
.k-right-icon {
  flex-basis: 70px;
  display: flex;
  color: $primary;
}

.k-left-icon {
  justify-content: flex-start;
  align-items: flex-start;
}

.k-right-icon {
  justify-content: flex-end;
  margin-left: auto;
}


.k-invitation {
  padding: 10px;
  border-bottom: 1px solid $white;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.k-participant-icons {
  padding-right: 10px;
  min-width: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.k-participant-icon {
  line-height: 1;
  display: flex;

  align-items: center;
}

.k-flex-address {
  flex-grow: 1;
}

.k-flex-visit-date {
  flex-basis: 100px;
  flex-grow: 0;
}


</style>
